import { render } from "./EditDeplasareDetail.vue?vue&type=template&id=783f92eb&scoped=true&ts=true"
import script from "./EditDeplasareDetail.ts?vue&type=script&lang=ts&external"
export * from "./EditDeplasareDetail.ts?vue&type=script&lang=ts&external"

import "./EditDeplasareDetail.vue?vue&type=style&index=0&id=783f92eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783f92eb"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QForm,QSpinner,QBtn,QTooltip,QMenu,QTable,QSpace,QInput,QIcon,QTr,QTd,QDialog,QCard,QBar,QCardSection,QLinearProgress,QField});qInstall(script, 'directives', {ClosePopup});
